import '../../libs/bulma.min.css';
import './PhoneForm.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faArrowAltCircleLeft } from '@fortawesome/free-solid-svg-icons';

function PhoneCreate(props) {
  const { save, handleChangeinput, cancel } = props;
  return (
    <div className="phone-form-card">
      <div className="phone-form-header">
        <svg className="phone-form-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
        </svg>
        <h3 className="phone-form-title">Adicionar Telefone</h3>
      </div>
      <form name="create-form" id="create-form" onSubmit={ (e) =>  e.preventDefault() }>
        <div className="phone-form-body">
          <div className="form-field-phone">
            <label className="form-label-phone">Número de telefone</label>
            <div className="form-control-phone">
              <input className="form-input-phone" name="numberphone" id="numberphone" type="text" onChange={(e) => handleChangeinput(e.target)} placeholder="Apenas números"/>
              <p name="numberphone-invalid-data" className='form-error-phone is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
            </div>
          </div>
        </div>
        <div className="phone-form-actions">
          <button className="btn-phone-action btn-save" type="submit" onClick={ () => save() }>
            <FontAwesomeIcon icon={ faSave } fixedWidth />
            <span>Salvar</span>
          </button>
          <button className="btn-phone-action btn-cancel" type="button" onClick={ () => cancel() }>
            <FontAwesomeIcon icon={ faArrowAltCircleLeft } fixedWidth />
            <span>Cancelar</span>
          </button>
        </div>
      </form>
    </div>
  );
}

export default PhoneCreate;
